// Logo officiel Clean My Life (PNG transparent fourni par la marque).
export const CmlMark = ({ className = "h-10 sm:h-12" }) => (
    <img
        src="/brand/logo.webp"
        alt="Clean My Life — nettoyage automobile à domicile à Cannes"
        data-testid="cml-logo"
        className={`w-auto object-contain ${className}`}
    />
);

export const SectionTitle = ({ eyebrow, title, sub }) => (
    <div className="mb-12 max-w-2xl">
        <p className="mb-3 font-mono text-xs font-semibold uppercase tracking-[0.35em] text-neon/90">
            {eyebrow}
        </p>
        <h2 className="font-display text-3xl font-bold tracking-tight text-white sm:text-4xl">
            {title}
        </h2>
        {sub && <p className="mt-4 text-base text-slate-400 sm:text-lg">{sub}</p>}
    </div>
);
